import styled from 'styled-components'

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: flex-end;
  grid-gap: 0.25rem;
`

export const Actions = styled.div`
  display: flex;
  height: 40px;
`
